<tt-card *ngIf="ready">
    <tt-toast [hidden]="!pendingChanges" ttType="warning" ttTitle="you_have_unsaved_changes"></tt-toast>
    <div style="display: flex; align-items: center; padding: 0.2rem 0">
        <button class="tt-cal-view__year-button" (click)="get!.year = +get!.year - 1; generateMonthsForSelectedYear(); loadEvents()">
            <span class="far fa-chevron-left"></span>
        </button>

        <h3 class="tt-card__heading" style="display: inline; padding: 0; margin: 0">{{ get!.year }}</h3>

        <button class="tt-cal-view__year-button" (click)="get!.year = +get!.year + 1; generateMonthsForSelectedYear(); loadEvents()">
            <span class="far fa-chevron-right"></span>
        </button>

        <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
        <tt-button-save *ngIf="get!.show_transfer_button === '1'" ttText="transfer_to_powtime" ttIcon="fas fa-exchange" (ttClick)="transfer()" [ttLoading]="transferring"></tt-button-save>
        <tt-button ttText="refresh" ttIcon="fas fa-sync-alt" (ttClick)="refresh()" [ttLoading]="refreshing"></tt-button>
    </div>
    <mat-chip-listbox class="tt-cal-view__mat-chip-listbox" (change)="activeCode = $event.value; selectable = !!activeCode">
        <mat-chip-option [matTooltip]="translations.calview_clear_tooltip" class="tt-cal-view__mat-chip-option" [value]="{}">
            <span>{{ translations.clear }}</span>
        </mat-chip-option>
        <mat-chip-option
            class="tt-cal-view__mat-chip-option"
            *ngFor="let offDutyCode of offDutyCodes"
            [style.backgroundColor]="offDutyCode.background_color_hex"
            [style.color]="offDutyCode.text_color_hex"
            [value]="offDutyCode"
        >
            <span [style.color]="offDutyCode.text_color_hex"> {{ offDutyCode.offdutycode_name }} </span>
        </mat-chip-option>
    </mat-chip-listbox>
</tt-card>
<tt-card class="flex-1" style="overflow: auto">
    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; row-gap: 1.6rem; column-gap: 1.6rem; width: 100%; overflow: auto; flex-grow: 1">
        <div *ngFor="let month of months" class="month-wrap">
            <div class="week-col">
                <div class="week-cell" *ngFor="let w of weekNumbersForMonth(month)">
                    {{ w }}
                </div>
            </div>

            <kendo-scheduler
                class="month-scheduler"
                kendoSchedulerSlotSelectable
                [selectable]="selectable"
                (slotDragEnd)="onSlotSelected($event)"
                [kendoSchedulerBinding]="events"
                [eventStyles]="eventStyles"
                [weekStart]="1"
                [selectedDate]="month"
            >
                <ng-template kendoSchedulerToolbarTemplate>
                    {{ month | date: "MMMM" }}
                </ng-template>

                <ng-template kendoSchedulerEventTemplate let-event="event">
                    <span class="tt-cal-view__event" [title]="event.dataItem.tooltip">
                        <!-- {{ event | json }} -->

                        <span *ngFor="let icon of event.dataItem.icons" [ngClass]="icon.icon" [style.color]="icon.color"></span>
                        <span class="tt-cal-view__event-text">{{ event.title }}</span>
                    </span>
                </ng-template>
                <kendo-scheduler-month-view> </kendo-scheduler-month-view>
            </kendo-scheduler>
        </div>
    </div>
</tt-card>
